import ListadoUsuarios from './Administracion/listado-usuarios';
import ListadoPerfil from './Administracion/listado-perfiles';
import Perfil from './Administracion/perfil';
import Usuario from './Administracion/usuario';
import Permisos from './Administracion/permisos';
import ListadoPedidos from './Compras/listado-pedidos';
import ListadoClientes from './Catalogos/listado-clientes';
import ListadoProductos from './Catalogos/listado-productos';
import Producto from './Catalogos/producto';
import Cliente from './Catalogos/cliente';
import ListadoClienteProspecto from './Catalogos/listado-clientes-prospecto';
import ClienteProspecto from './Catalogos/cliente-prospecto';
import Venta from './Ventas/venta';
import ListadoVentas from './Ventas/listado-ventas';
import ListadoVentasAlmacenadas from './Ventas/listado-ventas-almacenadas';
import VentaAlmacenada from './Ventas/venta-almacenada';
import ListadoDistribuidoras from './Catalogos/listado-distribuidoras';
import Distribuidora from './Catalogos/distribuidora';
import VentaRealizada from './Ventas/venta-realizada';
import ListadoConteosInventario from './Inventario/listado-conteos-inventario';
import ConteoInventario from './Inventario/conteo-inventario';
import ListadoSalidasInventario from './Inventario/listado-salidas-inventario';
import SalidaInventario from './Inventario/salida-inventario';
import ListadoEntradasInventario from './Inventario/listado-entradas-inventario';
import EntradaInventario from './Inventario/entrada-inventario';

import ReportePedidos from './Compras/reporte-pedidos';
import { getServiceData } from "../store/global-services";
import React, { useEffect, useState } from "react";
import ListadoPrecios from './Catalogos/listado-precios';
import Inventario from './Inventario/inventario';


const ScreenManager = (props: any) => {
    const { screen, snackHandleOpen } = props;
    const [ section, setSection ] = useState<any>(<></>); //
    const Secciones: any = {
        ListadoUsuarios: '5',
        Usuario: '5',
        ListadoPerfil: '6',
        Perfil: '6',
        Permisos: '7',
        Producto: '8',
        ListadoProductos: '8',
        Distribuidora: '9',
        ListadoDistribuidoras: '9',
        ListadoClientes: '10',
        Cliente: '10',
        ListadoClientesProspecto: '11',
        ClienteProspecto: '11',
        Venta: '12',
        ListadoVentasAlmacenadas: '13',
        Inventario: '14',
        ListadoVentas: '15',
        ListadoPrecios: '17',
        VentaAlmacenada: '18',
        VentaRealizada: '12',
        ListadoConteoInventario: '19',
        ConteoInventario: '19',
        ListadoEntradasInventario: '20',
        ListadoSalidasInventario: '21',
        EntradaInventario: '20',
        SalidaInventario: '22',
        InventarioActual: '14',
        /////////------------------------------------
        //ListadoPedidos: '12',
        //ReportePedidos: '15',
        
        
    }
    useEffect(() => {
        setSection(<></>);
        getServiceData({ nombre: 'usuario/acceso/' + Secciones[screen] }).then(data => {
            if (data.success)
                setSection(getSection(screen, snackHandleOpen));
            else
                snackHandleOpen({ open: true, message: data.message, color: 'red' });
        }); 
    }, [screen]);
    return <>{section}</>;
};
const getSection = (screen: string, snackHandleOpen: any) => {
    switch (screen) {
        case 'ListadoUsuarios':
            return <ListadoUsuarios snackHandleOpen={snackHandleOpen} />;
        case 'Usuario': 
            return <Usuario snackHandleOpen={snackHandleOpen} />;
        case 'ListadoPerfil':
            return <ListadoPerfil snackHandleOpen={snackHandleOpen} />;
        case 'Perfil':
            return <Perfil snackHandleOpen={snackHandleOpen} />;
        case 'Permisos':
            return <Permisos snackHandleOpen={snackHandleOpen} />;
        case 'ListadoProductos':
            return <ListadoProductos snackHandleOpen={snackHandleOpen} />;
        case 'Producto':
            return <Producto snackHandleOpen={snackHandleOpen} />;
        case 'ListadoDistribuidoras':
            return <ListadoDistribuidoras snackHandleOpen={snackHandleOpen} />;
        case 'Distribuidora':
            return <Distribuidora snackHandleOpen={snackHandleOpen} />;
        case 'ListadoClientes':
            return <ListadoClientes snackHandleOpen={snackHandleOpen} />;
        case 'Cliente':
            return <Cliente snackHandleOpen={snackHandleOpen} />;
        case 'ListadoClientesProspecto':
            return <ListadoClienteProspecto snackHandleOpen={snackHandleOpen} />;
        case 'ClienteProspecto':
            return <ClienteProspecto snackHandleOpen={snackHandleOpen} />;
        case 'Venta':
            return <Venta snackHandleOpen={snackHandleOpen} />;
        case 'ListadoVentasAlmacenadas':
            return <ListadoVentasAlmacenadas snackHandleOpen={snackHandleOpen} />;
        case 'VentaAlmacenada':
            return <VentaAlmacenada snackHandleOpen={snackHandleOpen} />;
        case 'ListadoVentas':
            return <ListadoVentas snackHandleOpen={snackHandleOpen} />;
        case 'ListadoPrecios':
            return <ListadoPrecios snackHandleOpen={snackHandleOpen} />;
        case 'Inventario':
            return <Inventario snackHandleOpen={snackHandleOpen} />;
        case 'VentaRealizada':
            return <VentaRealizada snackHandleOpen={snackHandleOpen} />;
        case 'ListadoConteoInventario':
            return <ListadoConteosInventario snackHandleOpen={snackHandleOpen} />;
        case 'ConteoInventario':
            return <ConteoInventario snackHandleOpen={snackHandleOpen} />;
        case 'ListadoEntradasInventario':
            return <ListadoEntradasInventario snackHandleOpen={snackHandleOpen} />;
        case 'EntradaInventario':
            return <EntradaInventario snackHandleOpen={snackHandleOpen} />;
        case 'ListadoSalidasInventario':
            return <ListadoSalidasInventario snackHandleOpen={snackHandleOpen} />;
        case 'SalidaInventario':
            return <SalidaInventario snackHandleOpen={snackHandleOpen} />;
        case 'InventarioActual':
            return <Inventario snackHandleOpen={snackHandleOpen} />;
        /////////------------------------------------
        case 'ListadoPedidos':
            return <ListadoPedidos snackHandleOpen={snackHandleOpen} />;
        case 'ReportePedidos':
            return <ReportePedidos snackHandleOpen={snackHandleOpen} />;
        default:    
            return <></>;
    }   
}

export default ScreenManager;